import { CodeIcon } from "@heroicons/react/solid";
import React from "react";
import { projects } from "../data";

export default function Projects() {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container border-t-4 p-4 border-gray-800 px-5 py-10 mx-auto text-center lg:px-10">
        <div className="flex flex-col w-full mb-10">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            Projects
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            Throughout my academic career, I've had the opportunity to apply the skills
            I have learned in interesting ways. Here are some projects I've worked on.
          </p>
        </div>
        <div className="flex flex-wrap m-4 p-5">
          {projects.map((project) => (
            <div className="flex flex-wrap py-10 items-center">
                <a
                href={project.link}
                key={project.image}
                className="w-full md:w-1/2 px-10">
                <div className="flex relative">
                    <img
                    alt="gallery"
                    className="relative inset-0 w-full h-full object-cover object-center"
                    src={project.image}
                    />
                </div>
                </a>
                <div className="w-full md:w-1/2">
                    <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                        {project.subtitle}
                    </h2>
                    <h1 className="title-font text-lg font-medium text-white mb-3">
                        {project.title}
                    </h1>
                    <p>{project.description}</p>
                </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}